import React, { useCallback, useContext, useState } from 'react';
import { AdacButtonWithLoader } from '../index';
import cx from 'classnames';
import SignatureCanvas from 'react-signature-canvas';
import messages from './SignDocumentComponent.messages';
import metadata from './SignDocumentComponent.metadata.json5';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm, ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import _ from 'lodash';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import styles from './SignDocumentComponent.module.scss';
import usePortalModeBasedLabel from 'gw-capability-fnol-adac-react/hooks/usePortalModeBasedLabel';

function SignDocumentComponent({
    canvasRef,
    setIsDocumentSigned,
    isDocumentSigned,
    isSendingDocument,
    submitDocumentSign
}) {
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const [documentVM, setDocumentVM] = useState(null);

    const updateDocumentVM = useCallback((value, path) => {
        const newVM = viewModelService.clone(documentVM);
        _.set(newVM, `${path}.value`, value);
        setDocumentVM(newVM);
    }, [documentVM, viewModelService, setDocumentVM]);

    const onSignature = useCallback(() => {
        setIsDocumentSigned(!canvasRef.current.isEmpty());
    }, [setIsDocumentSigned]);

    const correctTheSignature = useCallback(() => {
        canvasRef.current.clear();
        setIsDocumentSigned(false);
    }, [setIsDocumentSigned]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrides = {
        signatureNotice: {
            content : usePortalModeBasedLabel('signDocument')
        },
        signaturecanvas: {
            canvasProps: { className: cx(styles.sigCanvasContent) },
            ref: canvasRef
        },
        correctSignatureButton: {
            disabled: !isDocumentSigned || isSendingDocument
        },
        sendButton: {
            onClick: submitDocumentSign,
            disabled: !isDocumentSigned || isSendingDocument,
            label: translator(messages.sendButton),
            isLoading: isSendingDocument
        },
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.pageContent, documentVM, id, path, overrides);
        },
        [documentVM, overrides]
    );


    const resolvers = {
        resolveClassNameMap: styles,
        resolveValue: readValue,
        resolveComponentMap: {
            signaturecanvas: SignatureCanvas,
            buttonWitLoader: AdacButtonWithLoader
        },
        resolveCallbackMap: {
            correctTheSignatureClick: correctTheSignature,
            onSignature: onSignature,
        }
    };

    return (
        <ViewModelForm
            model={documentVM}
            uiProps={metadata.pageContent}
            overrideProps={overrides}
            resolveValue={readValue}
            onValueChange={updateDocumentVM}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

export default SignDocumentComponent;
